import { observer } from 'mobx-react-lite'
import { BinaryOperationFilter } from '@/features/legends/filters/components/BinaryOperationFilter'
import type { BinaryOperationEditorViewModel } from '@/features/legends/filters/types/BinaryOperationEditorViewModel'
import { SymbolConnectorContainer } from '@/features/legends/symbols/components/SymbolConnector/SymbolConnectorContainer'

export interface BinaryOperationFilterContainerProps {
  vm: BinaryOperationEditorViewModel
  isDisabled?: boolean
  testId?: string
}

export const BinaryOperationFilterContainer = observer(
  function BinaryOperationFilterContainer({
    vm,
    isDisabled,
    testId,
  }: BinaryOperationFilterContainerProps) {
    return (
      <BinaryOperationFilter
        target={
          <SymbolConnectorContainer
            vm={vm.target}
            isDisabled={isDisabled}
            aria-label="Target"
            testId={testId && `${testId}-target`}
          />
        }
        op={vm.op}
        ops={vm.availableOps}
        onOpChange={vm.setOp}
        valueType={vm.valueInputType}
        value={vm.value}
        valueOptions={vm.predefinedOptions}
        onValueChange={vm.setValue}
        // The connector shows its own errors, so this only adds the
        // analyzer's.
        targetError={
          vm.target.validation.getError('symbol')
            ? undefined
            : vm.validation.getError('target')
        }
        opError={vm.validation.getError('op')}
        valueError={vm.validation.getError('value')}
        isDisabled={isDisabled}
        testId={testId}
      />
    )
  },
)
